import 'babel-polyfill';
import './bugsnag';

// General import
import Lodash from 'lodash';
import Vue from 'vue';
import LineClamp from 'vue-line-clamp';
import Vuelidate from 'vuelidate';
import Axios from 'axios';
import VueCarousel from 'vue-carousel';
import VueAxios from 'vue-axios';
import VueCookie from 'vue-cookie';
import VueMultiselect from 'vue-multiselect';
import VueSessionStorage from 'vue-sessionstorage';
import Notifications from 'vue-notification';
import VTooltip from 'v-tooltip'
import VueLocalStorage from 'vue-localstorage'
import * as VueGoogleMaps from "vue2-google-maps"
// Directives
import dataHref from './directives/dataHref';
// Transitions
import SlideToggle from './transitions/SlideToggle'
// Import components
import Alerts from '../components/Alerts';
import AvatarUpload from '../components/AvatarUpload';
import CarouselHome from '../components/CarouselHome'
import CookieBar from '../components/CookieBar';
import Kennisbank from '../components/Kennisbank';
import LatestAlert from '../components/LatestAlert';
import Login from '../components/Login';
import Faq from '../components/Faq';
import FormContact from '../components/FormContact';
import Profile from '../components/Profile';
import Spinner from 'vue-spinner-component/src/Spinner';
import Vragenlijst from '../components/Vragenlijst'
import VragenlijstIndex from '../components/VragenlijstIndex'
import OrganismsIndex from '../components/organisms/OrganismsIndex'
import OrganismsVragenlijst from '../components/organisms/OrganismsVragenlijst'
import OrganismsDetail from '../components/organisms/OrganismsDetail'
import OrganismsQuestion from '../components/organisms/OrganismsQuestion'
import XylellaIndex from '../components/xylella/XylellaIndex';
import XylellaInfectedLoc from '../components/xylella/XylellaInfectedLoc';
import XylellaVragenlijst from '../components/xylella/XylellaVragenlijst';
import XylellaVragenlijstIndex from '../components/xylella/XylellaVragenlijstIndex'

Vue.use(Lodash);
Vue.use(LineClamp);
Vue.use(VueAxios, Axios);
Vue.use(VueCookie);
Vue.use(VueMultiselect);
Vue.use(Vuelidate);
Vue.use(VueSessionStorage);
Vue.use(VueCarousel);
Vue.use(VTooltip);
Vue.use(Notifications);
Vue.use(VueLocalStorage);
Vue.use(VueGoogleMaps, {
  load: {
    region: 'NL',
    key: process.env.MIX_GOOGLE_MAPS_API_KEY,
    libraries: "places"
  }
});

Vue.directive('data-href', dataHref);
Vue.component('transition-slide-toggle', SlideToggle);


new Vue({
  el: '#vue-container',
  components: {
    Alerts,
    AvatarUpload,
    CarouselHome,
    CookieBar,
    Faq,
    FormContact,
    Kennisbank,
    LatestAlert,
    Login,
    Profile,
    Spinner,
    Vragenlijst,
    OrganismsQuestion,
    VragenlijstIndex,
    OrganismsIndex,
    OrganismsVragenlijst,
    OrganismsDetail,
    XylellaIndex,
    XylellaInfectedLoc,
    XylellaVragenlijst,
    XylellaVragenlijstIndex
  },
  data() {
    return {
      menuActive: false,
    };
  },
  methods: {
    menu() {
      this.menuActive = !this.menuActive;

      let body = document.querySelector('body');

      if (this.menuActive) {
        body.classList.add('menu-opened');
      } else {
        body.classList.remove('menu-opened');
      }
    },
  },
  created() {
    this.axios.defaults.headers.common = {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': document.querySelector('meta[name="_token"]').getAttribute('content'),
    };
  },
});

Vue.config.productionTip = false;

//Whitelabel
/*console.log('%c__         __    _', 'font-family: monospace; color: #56C3D7; font-weight: bold');
console.log('%c\\ \\   _   / /__ | |__  ___ ____  _ _', 'font-family: monospace; color: #56C3D7; font-weight: bold');
console.log('%c \\ \\ / \\ / / _ \\| \'_ \\/ _ \\__  \\| | |', 'font-family: monospace; color: #56C3D7; font-weight: bold');
console.log('%c  \\ \\ / \\ /| __/| |_) | __// _ || | | ', 'font-family: monospace; color: #56C3D7; font-weight: bold');
console.log('%c   \\_/ \\_/ \\___||_.__/\\___|\\___|\\___/', 'font-family: monospace; color: #56C3D7; font-weight: bold');
console.log(' ');
console.log('%cSpreek jij onze taal?', 'font-weight: bold; color: black;');
console.log('%cGa naar https://webeau.nl/vacatures', 'font-weight: bold; color: black;');
console.log(' ');*/
